import React, { useEffect, useRef } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'

import { AppSelectField } from 'components/Common/AppFormFields/AppSelectField/AppSelectField.component'
import { AppBadge } from 'components/Common/AppBadge/AppBadge.component'
import { goalCategoryLabelsValues, categoryType } from 'appConfig/data'
import { getColorForGoalCategory } from 'appUtils'
import { FieldLabel } from 'components/AppKanbanBoard/AppTask/AppTask.style'
import { TaskFormFields } from 'components/AppKanbanBoard/config'

interface IAppTaskCategoryFieldProps {
  methods: UseFormReturn
  clickedFields: { [key: string]: boolean }
  handleClick: (field: string, isHovered: boolean) => void
}

export const AppTaskCategoryField: React.FC<IAppTaskCategoryFieldProps> = ({
  methods,
  clickedFields,
  handleClick,
}) => {
  const categoryWrapperRef = useRef<HTMLDivElement | null>(null)

  const {
    control,
    formState: { errors },
  } = methods

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        categoryWrapperRef.current &&
        !categoryWrapperRef.current.contains(event.target as Node)
      ) {
        handleClick(TaskFormFields.category, false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [handleClick])

  return (
    <>
      <FieldLabel>Business Function</FieldLabel>
      <div className="col-span-7 font-inter text-black-dark">
        <Controller
          name={TaskFormFields.category}
          control={control}
          render={({ field }) => (
            <>
              {clickedFields.category ? (
                <div className="flex items-center w-2/3" ref={categoryWrapperRef}>
                  <AppSelectField
                    size="sm"
                    {...field}
                    options={goalCategoryLabelsValues}
                    placeholder="Select business function"
                    errors={errors.category?.message as string}
                    onBlur={() => handleClick(field.name, false)}
                    onChange={(e) => {
                      field.onChange(e.value)
                      handleClick(field.name, false)
                    }}
                  />
                </div>
              ) : (
                <div className="hover:cursor-pointer" onClick={() => handleClick(field.name, true)}>
                  {field.value ? (
                    <AppBadge
                      size="sm"
                      type="Filled"
                      color={getColorForGoalCategory(field.value)}
                      label={categoryType[field.value]}
                    />
                  ) : (
                    <div className="!font-inter text-black-dark">Select business function</div>
                  )}
                </div>
              )}
            </>
          )}
        />
      </div>
    </>
  )
}
